/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Categories_HeadingInputs */

const en_visa_categories_heading = /** @type {(inputs: Visa_Categories_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find Your Pathway`)
};

const pt_visa_categories_heading = /** @type {(inputs: Visa_Categories_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre Seu Caminho`)
};

const es_visa_categories_heading = /** @type {(inputs: Visa_Categories_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentre Su Camino`)
};

/**
* | output |
* | --- |
* | "Find Your Pathway" |
*
* @param {Visa_Categories_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_categories_heading = /** @type {((inputs?: Visa_Categories_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Categories_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_categories_heading(inputs)
	if (locale === "es") return es_visa_categories_heading(inputs)
	return en_visa_categories_heading(inputs)
});